import PublicationGroup from './PublicationGroup';

export default PublicationGroup;
